import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon"
import Header from "../../components/Header/Header"
import SideNavbar from "../../components/Navbar/SideNavbar"
import PromoCodeListForm from "../../components/PromoCodeList/PromoCodeListForm"
import { useNavigate } from "react-router-dom"

interface PromoCodeCreateFormProps {
    mode?: "create" | "update";
}

const PromoCodeCreateForm = ({ mode = "create" }: PromoCodeCreateFormProps) => {
    const { promoCode } = useParams();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (mode === "update" && promoCode) {
            setLoading(true);
            setError("");
            const fetchDetails = async () => {
                try {
                    const params = new URLSearchParams();
                    params.append("promoCode", promoCode);
                    const res = await fetch(`${process.env.REACT_APP_CMS_SERVICE}/cmsApi/v1/promocode/details?${params}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                        },
                        body: params.toString()
                    });
                    if (!res.ok) throw new Error("Failed to fetch coupon details");
                    const json = await res.json();
                    setInitialData(json.data);
                } catch (err: any) {
                    setError(err.message || "Unknown error");
                } finally {
                    setLoading(false);
                }
            };
            fetchDetails();
        }
    }, [mode, promoCode]);

    if (mode === "update") {
        if (loading) return <div className="p-4 text-center">Loading coupon details...</div>;
        if (error) return <div className="p-4 text-center text-red-500">{error}</div>;
        if (!initialData) return null;
    }

    const leftArrorClickHandler = () => {
        navigate("/promoCode-list")
    }

    return (
        <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <div className="Subheader bg-white p-[15px] shadow-[0_2px_6px_rgba(0,0,0,.1)]">
                            <p className="text-xl font-bold text-[#43425D] flex items-center">
                                <ArrowLeftSLineIcon  onClick={leftArrorClickHandler} size={24} className="mr-4" />
                                {mode === "update" ? "Update PromoCode " : "Create PromoCode "}

                            </p>
                        </div>
                        <PromoCodeListForm
            mode={mode as "create" | "update"}
            initialData={mode === "update" ? initialData : undefined}
        />
                    </div>
                </div>
            </div>


    );
};

export default PromoCodeCreateForm;